import { Link } from 'react-router-dom'
import { AuthLayout } from '@/modules/auth/ui/components'
import { Button } from '@/shared/ui/primitives'

export function AuthCodeErrorPage() {
  return (
    <AuthLayout
      title="We couldn't sign you in"
      subtitle="Your sign-in link is no longer valid."
    >
      <div data-testid="auth-code-error" className="flex flex-col gap-4">
        <ul className="ml-5 list-disc text-sm text-muted-foreground">
          <li>The link may have expired.</li>
          <li>It may have already been used.</li>
          <li>It may have been opened in a different browser.</li>
        </ul>
        <Button asChild variant="default" className="w-full">
          <Link to="/auth/verify-email">Request a new magic link</Link>
        </Button>
        <Button asChild variant="outline" className="w-full">
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </AuthLayout>
  )
}
